import { Cancel, CheckCircle, Pending, Timelapse } from '@mui/icons-material';
import React from 'react';

export default function StatusIcon({ status }) {
	switch (status) {
		case 'pending':
			return (
				<Pending fontSize='large' sx={{ margin: '0 auto', color: '#FFD600' }} />
			);
		case 'inProgress':
			return (
				<Timelapse
					fontSize='large'
					sx={{ margin: '0 auto', color: '#1261BF' }}
				/>
			);
		case 'done':
			return (
				<CheckCircle
					fontSize='large'
					sx={{ margin: '0 auto', color: '#04BE00' }}
				/>
			);
		case 'cancel':
			return (
				<Cancel fontSize='large' sx={{ margin: '0 auto', color: '#CA0505' }} />
			);

		default:
			return 0;
	}
}
